import {
  Speaker, Tv, Coffee, Laptop, Smartphone, Camera, Car, Watch, Gamepad2, Wind,
  Headphones, ChefHat, Wrench, Banknote, Plane, Ship, ShieldCheck, Package,
} from "lucide-react";

/**
 * Map category / product name to a Lucide icon.
 * Trust-first: we NEVER fall back to random stock photos. If we can't match
 * confidently we return a neutral Package icon so users are never misled by
 * an unrelated image.
 */
export function pickCategoryIcon(category = "", name = "") {
  const s = `${category} ${name}`.toLowerCase();
  if (/(speaker|soundbar|audio system)/.test(s)) return Speaker;
  if (/(headphone|earbud|earphone|airpod)/.test(s)) return Headphones;
  if (/(tv|television|oled|qled)/.test(s)) return Tv;
  if (/(coffee|espresso|barista)/.test(s)) return Coffee;
  if (/(laptop|macbook|notebook|chromebook|computer|pc)/.test(s)) return Laptop;
  if (/(phone|iphone|pixel|galaxy|smartphone|mobile)/.test(s)) return Smartphone;
  if (/(camera|lens|gopro|mirrorless|dslr)/.test(s)) return Camera;
  if (/(car|tesla|ev|hybrid|suv|hatchback|vehicle)/.test(s)) return Car;
  if (/(watch|smartwatch|fitness tracker)/.test(s)) return Watch;
  if (/(gaming|console|playstation|xbox|nintendo)/.test(s)) return Gamepad2;
  if (/(vacuum|dyson|hoover|cordless cleaner)/.test(s)) return Wind;
  if (/(fryer|kettle|toaster|kitchen|blender|mixer|microwave)/.test(s)) return ChefHat;
  if (/(drill|tool|diy|saw|sander)/.test(s)) return Wrench;
  if (/(mortgage|loan|finance|isa|saving|investment)/.test(s)) return Banknote;
  if (/(flight|airline|holiday)/.test(s)) return Plane;
  if (/(cruise|ship|boat)/.test(s)) return Ship;
  if (/(insurance|cover|warranty)/.test(s)) return ShieldCheck;
  return Package;
}
